import React, { forwardRef } from "react";

const formatNum = (n) =>
  Number(n || 0).toLocaleString("en-PK", { maximumFractionDigits: 0 });

const formatRs = (n) => `Rs ${formatNum(n)}`;

const thStyle = {
  border: "1px solid #fff",
  backgroundColor: "#155f60",
  color: "#fff",
  padding: "8px 10px",
  textAlign: "left",
  fontSize: "12px",
  fontWeight: 700,
};

const tdStyle = {
  border: "1px solid #155f60",
  padding: "7px 10px",
  fontSize: "12px",
  color: "#155f60",
};

const sectionTitleStyle = {
  background: "#155f60",
  color: "#fff",
  textAlign: "center",
  fontWeight: 700,
  fontSize: "16px",
  padding: "10px 8px",
  margin: "4px 0 0",
};

const statBoxStyle = {
  border: "2px solid #155f60",
  padding: "10px 12px",
  background: "#fff",
};

const CustomerItemSummaryA4Document = forwardRef(
  (
    {
      customer,
      rows = [],
      tabLabel = "All",
      stats = {},
    },
    ref
  ) => {
    const displayRows = Array.isArray(rows) ? rows : [];

    return (
      <div
        ref={ref}
        className="customer-item-summary-a4 bg-card text-ink"
        style={{
          width: "794px",
          maxWidth: "794px",
          fontFamily: "Arial, Helvetica, sans-serif",
          boxSizing: "border-box",
          padding: "12px",
        }}
      >
        <img
          src="/banner.jpeg"
          alt="Irshad Carton Dealer"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            border: "2px solid #002650",
            borderRadius: "8px 8px 0 0",
          }}
        />

        <div style={sectionTitleStyle}>Customer Details</div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            border: "2px solid #155f60",
            borderTop: "none",
          }}
        >
          {[
            ["Name", customer?.name],
            ["Contact", customer?.contact],
            ["Address", customer?.address],
          ].map(([label, value]) => (
            <div
              key={label}
              style={{
                padding: "10px 12px",
                borderRight: label !== "Address" ? "1px solid #155f60" : "none",
              }}
            >
              <div style={{ fontSize: "11px", color: "#8A9496", marginBottom: 4 }}>
                {label}
              </div>
              <div style={{ fontSize: "13px", fontWeight: 700 }}>{value || "—"}</div>
            </div>
          ))}
        </div>

        <div style={sectionTitleStyle}>
          Customer Item Summary ({tabLabel})
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: 4,
            tableLayout: "fixed",
          }}
        >
          <colgroup>
            <col style={{ width: "38%" }} />
            <col style={{ width: "12%" }} />
            <col style={{ width: "16%" }} />
            <col style={{ width: "14%" }} />
            <col style={{ width: "20%" }} />
          </colgroup>
          <thead>
            <tr>
              <th style={thStyle}>Item Name</th>
              <th style={thStyle}>Unit</th>
              <th style={thStyle}>Price</th>
              <th style={thStyle}>Qty</th>
              <th style={thStyle}>Total</th>
            </tr>
          </thead>
          <tbody>
            {displayRows.map((item, index) => {
              const isTotal = item.name === "Total";
              const rowTd = {
                ...tdStyle,
                ...(isTotal
                  ? {
                      backgroundColor: "#155f60",
                      color: "#fff",
                      fontWeight: 700,
                    }
                  : {}),
              };
              return (
                <tr key={`${item.name}-${index}`}>
                  <td style={rowTd}>{item.name}</td>
                  <td style={{ ...rowTd, textAlign: "center" }}>{item.type || "—"}</td>
                  <td style={{ ...rowTd, textAlign: "right" }}>
                    {formatNum(item.price)}
                  </td>
                  <td style={{ ...rowTd, textAlign: "right" }}>
                    {formatNum(item.qty)}
                  </td>
                  <td style={{ ...rowTd, textAlign: "right" }}>
                    {formatNum(item.amount)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "10px",
            marginTop: "16px",
          }}
        >
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
            {[
              ["Total Box", formatNum(stats.totalBox)],
              ["Total Shopping", formatNum(stats.totalShopping)],
              ["Opening Balance", formatRs(stats.openingBalance)],
              ["Discount Amount", formatRs(stats.discount)],
              ["Return Amount", formatRs(stats.returnAmount)],
            ].map(([label, value]) => (
              <div key={label} style={statBoxStyle}>
                <div style={{ fontSize: "11px", color: "#8A9496" }}>{label}</div>
                <div style={{ fontSize: "16px", fontWeight: 700, marginTop: 4 }}>
                  {value}
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "10px" }}>
            {[
              ["Total Amount", formatRs(stats.totalAmount)],
              ["Paid Amount", formatRs(stats.paid)],
              ["Remaining Amount", formatRs(stats.remaining)],
            ].map(([label, value]) => (
              <div key={label} style={statBoxStyle}>
                <div style={{ fontSize: "11px", color: "#8A9496" }}>{label}</div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: 700,
                    marginTop: 4,
                    color: label.includes("Remaining") ? "#D14343" : "#1A2426",
                  }}
                >
                  {value}
                </div>
              </div>
            ))}
          </div>
        </div>

        <p
          style={{
            textAlign: "center",
            fontSize: "10px",
            color: "#8A9496",
            marginTop: "14px",
          }}
        >
          Generated from Irshad Carton Dealer · {new Date().toLocaleString("en-PK")}
        </p>
      </div>
    );
  }
);

CustomerItemSummaryA4Document.displayName = "CustomerItemSummaryA4Document";

export default CustomerItemSummaryA4Document;
